import React from 'react';
import cl from 'classnames';

import { ClassName, TableViewType } from '../../../../../types';

interface IndexTableEmptyCellProps {
  tdClassName?: ClassName;
  viewType?: TableViewType;
}

function IndexTableEmptyCell({
  tdClassName,
  viewType
}: IndexTableEmptyCellProps) {
  return (
    <td
      className={
        tdClassName ||
        cl({
          'px-3 py-2': !viewType || viewType === TableViewType.DEFAULT,
          'px-3 py-0.5 text-xs font-mono': viewType === TableViewType.SLIM
        })
      }
    >
      {null}
    </td>
  );
}

export default IndexTableEmptyCell;
